export const environment = {
    production: true,
    title: 'kolumbus.betabike.no',
    mcs_template: 'BETABIKEK',
    main_url: 'https://api.kolumbus.betabike.no',
    api_url: 'https://api.kolumbus.betabike.no/api',
    insight_api_url: 'https://api.kolumbus.betabike.no/api',
    s3_image_url: 'https://mcs-betabike.s3-eu-west-1.amazonaws.com/',
    logo_title: 'BetaBike - Kolumbus',
    map_center_position: [5.73271, 58.96564],
    enable_insight: true,
    carto_api_key: 'cb1_2ak8_1_4fba9e9fb6e41a02f41bb1b4'
};
